export enum PataviumRole {
    Admin = 1,
    BackOfficeOperator = 2,
    Agency = 3,
    Agent = 4,
    AgencyOperator = 5,
    SpecializedOperator = 6
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/role.enum.model.ts